"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Add", {
  enumerable: true,
  get: function get() {
    return _Add["default"];
  }
});
Object.defineProperty(exports, "AddCircle", {
  enumerable: true,
  get: function get() {
    return _AddCircle["default"];
  }
});
Object.defineProperty(exports, "ArrowDoubleDown", {
  enumerable: true,
  get: function get() {
    return _ArrowDoubleDown["default"];
  }
});
Object.defineProperty(exports, "ArrowDoubleLeft", {
  enumerable: true,
  get: function get() {
    return _ArrowDoubleLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowDoubleRight", {
  enumerable: true,
  get: function get() {
    return _ArrowDoubleRight["default"];
  }
});
Object.defineProperty(exports, "ArrowDoubleUp", {
  enumerable: true,
  get: function get() {
    return _ArrowDoubleUp["default"];
  }
});
Object.defineProperty(exports, "ArrowDown", {
  enumerable: true,
  get: function get() {
    return _ArrowDown["default"];
  }
});
Object.defineProperty(exports, "ArrowLeft", {
  enumerable: true,
  get: function get() {
    return _ArrowLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowRight", {
  enumerable: true,
  get: function get() {
    return _ArrowRight["default"];
  }
});
Object.defineProperty(exports, "ArrowUp", {
  enumerable: true,
  get: function get() {
    return _ArrowUp["default"];
  }
});
Object.defineProperty(exports, "ArrowLongDown", {
  enumerable: true,
  get: function get() {
    return _ArrowLongDown["default"];
  }
});
Object.defineProperty(exports, "ArrowLongLeft", {
  enumerable: true,
  get: function get() {
    return _ArrowLongLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowLongRight", {
  enumerable: true,
  get: function get() {
    return _ArrowLongRight["default"];
  }
});
Object.defineProperty(exports, "ArrowLongUp", {
  enumerable: true,
  get: function get() {
    return _ArrowLongUp["default"];
  }
});
Object.defineProperty(exports, "ArrowFillDown", {
  enumerable: true,
  get: function get() {
    return _ArrowFillDown["default"];
  }
});
Object.defineProperty(exports, "ArrowFillLeft", {
  enumerable: true,
  get: function get() {
    return _ArrowFillLeft["default"];
  }
});
Object.defineProperty(exports, "ArrowFillRight", {
  enumerable: true,
  get: function get() {
    return _ArrowFillRight["default"];
  }
});
Object.defineProperty(exports, "ArrowFillUp", {
  enumerable: true,
  get: function get() {
    return _ArrowFillUp["default"];
  }
});
Object.defineProperty(exports, "Check", {
  enumerable: true,
  get: function get() {
    return _Check["default"];
  }
});
Object.defineProperty(exports, "Checked", {
  enumerable: true,
  get: function get() {
    return _Checked["default"];
  }
});
Object.defineProperty(exports, "CheckedAll", {
  enumerable: true,
  get: function get() {
    return _CheckedAll["default"];
  }
});
Object.defineProperty(exports, "Close", {
  enumerable: true,
  get: function get() {
    return _Close["default"];
  }
});
Object.defineProperty(exports, "CloseCircle", {
  enumerable: true,
  get: function get() {
    return _CloseCircle["default"];
  }
});
Object.defineProperty(exports, "Minus", {
  enumerable: true,
  get: function get() {
    return _Minus["default"];
  }
});
Object.defineProperty(exports, "Unchecked", {
  enumerable: true,
  get: function get() {
    return _Unchecked["default"];
  }
});
Object.defineProperty(exports, "UncheckedAll", {
  enumerable: true,
  get: function get() {
    return _UncheckedAll["default"];
  }
});
Object.defineProperty(exports, "Cn", {
  enumerable: true,
  get: function get() {
    return _Cn["default"];
  }
});
Object.defineProperty(exports, "Dev", {
  enumerable: true,
  get: function get() {
    return _Dev["default"];
  }
});
Object.defineProperty(exports, "Osn", {
  enumerable: true,
  get: function get() {
    return _Osn["default"];
  }
});
Object.defineProperty(exports, "Pn", {
  enumerable: true,
  get: function get() {
    return _Pn["default"];
  }
});
Object.defineProperty(exports, "Osnsocial", {
  enumerable: true,
  get: function get() {
    return _Osnsocial["default"];
  }
});
Object.defineProperty(exports, "Cellphone", {
  enumerable: true,
  get: function get() {
    return _Cellphone["default"];
  }
});
Object.defineProperty(exports, "Mail", {
  enumerable: true,
  get: function get() {
    return _Mail["default"];
  }
});
Object.defineProperty(exports, "Phone", {
  enumerable: true,
  get: function get() {
    return _Phone["default"];
  }
});
Object.defineProperty(exports, "Skype", {
  enumerable: true,
  get: function get() {
    return _Skype["default"];
  }
});
Object.defineProperty(exports, "SkypeSquare", {
  enumerable: true,
  get: function get() {
    return _SkypeSquare["default"];
  }
});
Object.defineProperty(exports, "Website", {
  enumerable: true,
  get: function get() {
    return _Website["default"];
  }
});
Object.defineProperty(exports, "Whatsapp", {
  enumerable: true,
  get: function get() {
    return _Whatsapp["default"];
  }
});
Object.defineProperty(exports, "WhatsappSquare", {
  enumerable: true,
  get: function get() {
    return _WhatsappSquare["default"];
  }
});
Object.defineProperty(exports, "Ads", {
  enumerable: true,
  get: function get() {
    return _Ads["default"];
  }
});
Object.defineProperty(exports, "Afternoon", {
  enumerable: true,
  get: function get() {
    return _Afternoon["default"];
  }
});
Object.defineProperty(exports, "Analytics", {
  enumerable: true,
  get: function get() {
    return _Analytics["default"];
  }
});
Object.defineProperty(exports, "Archive", {
  enumerable: true,
  get: function get() {
    return _Archive["default"];
  }
});
Object.defineProperty(exports, "Badge", {
  enumerable: true,
  get: function get() {
    return _Badge["default"];
  }
});
Object.defineProperty(exports, "BellFill", {
  enumerable: true,
  get: function get() {
    return _BellFill["default"];
  }
});
Object.defineProperty(exports, "Belgium", {
  enumerable: true,
  get: function get() {
    return _Belgium["default"];
  }
});
Object.defineProperty(exports, "Bin", {
  enumerable: true,
  get: function get() {
    return _Bin["default"];
  }
});
Object.defineProperty(exports, "Birthday", {
  enumerable: true,
  get: function get() {
    return _Birthday["default"];
  }
});
Object.defineProperty(exports, "Briefcase", {
  enumerable: true,
  get: function get() {
    return _Briefcase["default"];
  }
});
Object.defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function get() {
    return _Calendar["default"];
  }
});
Object.defineProperty(exports, "Chain", {
  enumerable: true,
  get: function get() {
    return _Chain["default"];
  }
});
Object.defineProperty(exports, "ChainBroken", {
  enumerable: true,
  get: function get() {
    return _ChainBroken["default"];
  }
});
Object.defineProperty(exports, "Clipboard", {
  enumerable: true,
  get: function get() {
    return _Clipboard["default"];
  }
});
Object.defineProperty(exports, "Coin", {
  enumerable: true,
  get: function get() {
    return _Coin["default"];
  }
});
Object.defineProperty(exports, "Copyright", {
  enumerable: true,
  get: function get() {
    return _Copyright["default"];
  }
});
Object.defineProperty(exports, "Cread", {
  enumerable: true,
  get: function get() {
    return _Cread["default"];
  }
});
Object.defineProperty(exports, "Crown", {
  enumerable: true,
  get: function get() {
    return _Crown["default"];
  }
});
Object.defineProperty(exports, "Dashboard", {
  enumerable: true,
  get: function get() {
    return _Dashboard["default"];
  }
});
Object.defineProperty(exports, "Discount", {
  enumerable: true,
  get: function get() {
    return _Discount["default"];
  }
});
Object.defineProperty(exports, "Dnd", {
  enumerable: true,
  get: function get() {
    return _Dnd["default"];
  }
});
Object.defineProperty(exports, "Edit", {
  enumerable: true,
  get: function get() {
    return _Edit["default"];
  }
});
Object.defineProperty(exports, "Entrepreneur", {
  enumerable: true,
  get: function get() {
    return _Entrepreneur["default"];
  }
});
Object.defineProperty(exports, "Eshop", {
  enumerable: true,
  get: function get() {
    return _Eshop["default"];
  }
});
Object.defineProperty(exports, "Facilities", {
  enumerable: true,
  get: function get() {
    return _Facilities["default"];
  }
});
Object.defineProperty(exports, "Favorite", {
  enumerable: true,
  get: function get() {
    return _Favorite["default"];
  }
});
Object.defineProperty(exports, "FavoriteFill", {
  enumerable: true,
  get: function get() {
    return _FavoriteFill["default"];
  }
});
Object.defineProperty(exports, "Fax", {
  enumerable: true,
  get: function get() {
    return _Fax["default"];
  }
});
Object.defineProperty(exports, "Filter", {
  enumerable: true,
  get: function get() {
    return _Filter["default"];
  }
});
Object.defineProperty(exports, "Groups", {
  enumerable: true,
  get: function get() {
    return _Groups["default"];
  }
});
Object.defineProperty(exports, "Hidden", {
  enumerable: true,
  get: function get() {
    return _Hidden["default"];
  }
});
Object.defineProperty(exports, "Home", {
  enumerable: true,
  get: function get() {
    return _Home["default"];
  }
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function get() {
    return _Image["default"];
  }
});
Object.defineProperty(exports, "Import", {
  enumerable: true,
  get: function get() {
    return _Import["default"];
  }
});
Object.defineProperty(exports, "InfinitySign", {
  enumerable: true,
  get: function get() {
    return _InfinitySign["default"];
  }
});
Object.defineProperty(exports, "Info", {
  enumerable: true,
  get: function get() {
    return _Info["default"];
  }
});
Object.defineProperty(exports, "Keywords", {
  enumerable: true,
  get: function get() {
    return _Keywords["default"];
  }
});
Object.defineProperty(exports, "Label", {
  enumerable: true,
  get: function get() {
    return _Label["default"];
  }
});
Object.defineProperty(exports, "Loading", {
  enumerable: true,
  get: function get() {
    return _Loading["default"];
  }
});
Object.defineProperty(exports, "Locked", {
  enumerable: true,
  get: function get() {
    return _Locked["default"];
  }
});
Object.defineProperty(exports, "Logout", {
  enumerable: true,
  get: function get() {
    return _Logout["default"];
  }
});
Object.defineProperty(exports, "Magazines", {
  enumerable: true,
  get: function get() {
    return _Magazines["default"];
  }
});
Object.defineProperty(exports, "Mapmarker", {
  enumerable: true,
  get: function get() {
    return _Mapmarker["default"];
  }
});
Object.defineProperty(exports, "MapmarkerFill", {
  enumerable: true,
  get: function get() {
    return _MapmarkerFill["default"];
  }
});
Object.defineProperty(exports, "Menudotted", {
  enumerable: true,
  get: function get() {
    return _Menudotted["default"];
  }
});
Object.defineProperty(exports, "MenudottedFill", {
  enumerable: true,
  get: function get() {
    return _MenudottedFill["default"];
  }
});
Object.defineProperty(exports, "MenuFill", {
  enumerable: true,
  get: function get() {
    return _MenuFill["default"];
  }
});
Object.defineProperty(exports, "Morning", {
  enumerable: true,
  get: function get() {
    return _Morning["default"];
  }
});
Object.defineProperty(exports, "Nacebel", {
  enumerable: true,
  get: function get() {
    return _Nacebel["default"];
  }
});
Object.defineProperty(exports, "Newsletter", {
  enumerable: true,
  get: function get() {
    return _Newsletter["default"];
  }
});
Object.defineProperty(exports, "OpeningHours", {
  enumerable: true,
  get: function get() {
    return _OpeningHours["default"];
  }
});
Object.defineProperty(exports, "OpenMap", {
  enumerable: true,
  get: function get() {
    return _OpenMap["default"];
  }
});
Object.defineProperty(exports, "PaperPlane", {
  enumerable: true,
  get: function get() {
    return _PaperPlane["default"];
  }
});
Object.defineProperty(exports, "Pin", {
  enumerable: true,
  get: function get() {
    return _Pin["default"];
  }
});
Object.defineProperty(exports, "PinFill", {
  enumerable: true,
  get: function get() {
    return _PinFill["default"];
  }
});
Object.defineProperty(exports, "Post", {
  enumerable: true,
  get: function get() {
    return _Post["default"];
  }
});
Object.defineProperty(exports, "Protection", {
  enumerable: true,
  get: function get() {
    return _Protection["default"];
  }
});
Object.defineProperty(exports, "Qr", {
  enumerable: true,
  get: function get() {
    return _Qr["default"];
  }
});
Object.defineProperty(exports, "QuoteClosed", {
  enumerable: true,
  get: function get() {
    return _QuoteClosed["default"];
  }
});
Object.defineProperty(exports, "QuoteClosedFill", {
  enumerable: true,
  get: function get() {
    return _QuoteClosedFill["default"];
  }
});
Object.defineProperty(exports, "QuoteOpen", {
  enumerable: true,
  get: function get() {
    return _QuoteOpen["default"];
  }
});
Object.defineProperty(exports, "QuoteOpenFill", {
  enumerable: true,
  get: function get() {
    return _QuoteOpenFill["default"];
  }
});
Object.defineProperty(exports, "Ranking", {
  enumerable: true,
  get: function get() {
    return _Ranking["default"];
  }
});
Object.defineProperty(exports, "Repeat", {
  enumerable: true,
  get: function get() {
    return _Repeat["default"];
  }
});
Object.defineProperty(exports, "Save", {
  enumerable: true,
  get: function get() {
    return _Save["default"];
  }
});
Object.defineProperty(exports, "Search", {
  enumerable: true,
  get: function get() {
    return _Search["default"];
  }
});
Object.defineProperty(exports, "Settings", {
  enumerable: true,
  get: function get() {
    return _Settings["default"];
  }
});
Object.defineProperty(exports, "Share", {
  enumerable: true,
  get: function get() {
    return _Share["default"];
  }
});
Object.defineProperty(exports, "Team", {
  enumerable: true,
  get: function get() {
    return _Team["default"];
  }
});
Object.defineProperty(exports, "ThumbsUp", {
  enumerable: true,
  get: function get() {
    return _ThumbsUp["default"];
  }
});
Object.defineProperty(exports, "Unlocked", {
  enumerable: true,
  get: function get() {
    return _Unlocked["default"];
  }
});
Object.defineProperty(exports, "Upload", {
  enumerable: true,
  get: function get() {
    return _Upload["default"];
  }
});
Object.defineProperty(exports, "UserF", {
  enumerable: true,
  get: function get() {
    return _UserF["default"];
  }
});
Object.defineProperty(exports, "UserM", {
  enumerable: true,
  get: function get() {
    return _UserM["default"];
  }
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function get() {
    return _Video["default"];
  }
});
Object.defineProperty(exports, "Visible", {
  enumerable: true,
  get: function get() {
    return _Visible["default"];
  }
});
Object.defineProperty(exports, "Computer", {
  enumerable: true,
  get: function get() {
    return _Computer["default"];
  }
});
Object.defineProperty(exports, "Bakery", {
  enumerable: true,
  get: function get() {
    return _Bakery["default"];
  }
});
Object.defineProperty(exports, "Verified", {
  enumerable: true,
  get: function get() {
    return _Verified["default"];
  }
});
Object.defineProperty(exports, "GaultMillau", {
  enumerable: true,
  get: function get() {
    return _GaultMillau["default"];
  }
});
Object.defineProperty(exports, "Michelin", {
  enumerable: true,
  get: function get() {
    return _Michelin["default"];
  }
});
Object.defineProperty(exports, "Michelin2star", {
  enumerable: true,
  get: function get() {
    return _Michelin2star["default"];
  }
});
Object.defineProperty(exports, "Michelin3star", {
  enumerable: true,
  get: function get() {
    return _Michelin3star["default"];
  }
});
Object.defineProperty(exports, "Star", {
  enumerable: true,
  get: function get() {
    return _Star["default"];
  }
});
Object.defineProperty(exports, "StarFill", {
  enumerable: true,
  get: function get() {
    return _StarFill["default"];
  }
});
Object.defineProperty(exports, "AC", {
  enumerable: true,
  get: function get() {
    return _AC["default"];
  }
});
Object.defineProperty(exports, "BpostFill", {
  enumerable: true,
  get: function get() {
    return _BpostFill["default"];
  }
});
Object.defineProperty(exports, "Breakfast", {
  enumerable: true,
  get: function get() {
    return _Breakfast["default"];
  }
});
Object.defineProperty(exports, "Gym", {
  enumerable: true,
  get: function get() {
    return _Gym["default"];
  }
});
Object.defineProperty(exports, "HotelBar", {
  enumerable: true,
  get: function get() {
    return _HotelBar["default"];
  }
});
Object.defineProperty(exports, "NoPetsAllowed", {
  enumerable: true,
  get: function get() {
    return _NoPetsAllowed["default"];
  }
});
Object.defineProperty(exports, "Parking", {
  enumerable: true,
  get: function get() {
    return _Parking["default"];
  }
});
Object.defineProperty(exports, "PetsAllowed", {
  enumerable: true,
  get: function get() {
    return _PetsAllowed["default"];
  }
});
Object.defineProperty(exports, "PicnicBench", {
  enumerable: true,
  get: function get() {
    return _PicnicBench["default"];
  }
});
Object.defineProperty(exports, "Restaurant", {
  enumerable: true,
  get: function get() {
    return _Restaurant["default"];
  }
});
Object.defineProperty(exports, "Spa", {
  enumerable: true,
  get: function get() {
    return _Spa["default"];
  }
});
Object.defineProperty(exports, "SwimmingPool", {
  enumerable: true,
  get: function get() {
    return _SwimmingPool["default"];
  }
});
Object.defineProperty(exports, "TwentyFourHourReception", {
  enumerable: true,
  get: function get() {
    return _TwentyFourHourReception["default"];
  }
});
Object.defineProperty(exports, "Ups", {
  enumerable: true,
  get: function get() {
    return _Ups["default"];
  }
});
Object.defineProperty(exports, "UpsFill", {
  enumerable: true,
  get: function get() {
    return _UpsFill["default"];
  }
});
Object.defineProperty(exports, "WeelchairFriendly", {
  enumerable: true,
  get: function get() {
    return _WeelchairFriendly["default"];
  }
});
Object.defineProperty(exports, "Wifi", {
  enumerable: true,
  get: function get() {
    return _Wifi["default"];
  }
});
Object.defineProperty(exports, "AmericanExpress", {
  enumerable: true,
  get: function get() {
    return _AmericanExpress["default"];
  }
});
Object.defineProperty(exports, "AndroidPay", {
  enumerable: true,
  get: function get() {
    return _AndroidPay["default"];
  }
});
Object.defineProperty(exports, "ApplePay", {
  enumerable: true,
  get: function get() {
    return _ApplePay["default"];
  }
});
Object.defineProperty(exports, "Bancontact", {
  enumerable: true,
  get: function get() {
    return _Bancontact["default"];
  }
});
Object.defineProperty(exports, "Bonz", {
  enumerable: true,
  get: function get() {
    return _Bonz["default"];
  }
});
Object.defineProperty(exports, "CashEuro", {
  enumerable: true,
  get: function get() {
    return _CashEuro["default"];
  }
});
Object.defineProperty(exports, "Ecopass", {
  enumerable: true,
  get: function get() {
    return _Ecopass["default"];
  }
});
Object.defineProperty(exports, "Edenred", {
  enumerable: true,
  get: function get() {
    return _Edenred["default"];
  }
});
Object.defineProperty(exports, "GiftVoucher", {
  enumerable: true,
  get: function get() {
    return _GiftVoucher["default"];
  }
});
Object.defineProperty(exports, "GooglePay", {
  enumerable: true,
  get: function get() {
    return _GooglePay["default"];
  }
});
Object.defineProperty(exports, "Maestro", {
  enumerable: true,
  get: function get() {
    return _Maestro["default"];
  }
});
Object.defineProperty(exports, "Mastercard", {
  enumerable: true,
  get: function get() {
    return _Mastercard["default"];
  }
});
Object.defineProperty(exports, "Monizze", {
  enumerable: true,
  get: function get() {
    return _Monizze["default"];
  }
});
Object.defineProperty(exports, "Payconiq", {
  enumerable: true,
  get: function get() {
    return _Payconiq["default"];
  }
});
Object.defineProperty(exports, "Sodexo", {
  enumerable: true,
  get: function get() {
    return _Sodexo["default"];
  }
});
Object.defineProperty(exports, "TicketEcocheque", {
  enumerable: true,
  get: function get() {
    return _TicketEcocheque["default"];
  }
});
Object.defineProperty(exports, "TicketRestaurant", {
  enumerable: true,
  get: function get() {
    return _TicketRestaurant["default"];
  }
});
Object.defineProperty(exports, "Visa", {
  enumerable: true,
  get: function get() {
    return _Visa["default"];
  }
});
Object.defineProperty(exports, "Vpay", {
  enumerable: true,
  get: function get() {
    return _Vpay["default"];
  }
});
Object.defineProperty(exports, "Behance", {
  enumerable: true,
  get: function get() {
    return _Behance["default"];
  }
});
Object.defineProperty(exports, "BehanceSquare", {
  enumerable: true,
  get: function get() {
    return _BehanceSquare["default"];
  }
});
Object.defineProperty(exports, "Deviantart", {
  enumerable: true,
  get: function get() {
    return _Deviantart["default"];
  }
});
Object.defineProperty(exports, "DeviantartSquare", {
  enumerable: true,
  get: function get() {
    return _DeviantartSquare["default"];
  }
});
Object.defineProperty(exports, "Dribbble", {
  enumerable: true,
  get: function get() {
    return _Dribbble["default"];
  }
});
Object.defineProperty(exports, "DribbbleSquare", {
  enumerable: true,
  get: function get() {
    return _DribbbleSquare["default"];
  }
});
Object.defineProperty(exports, "Facebook", {
  enumerable: true,
  get: function get() {
    return _Facebook["default"];
  }
});
Object.defineProperty(exports, "FacebookSquare", {
  enumerable: true,
  get: function get() {
    return _FacebookSquare["default"];
  }
});
Object.defineProperty(exports, "Flickr", {
  enumerable: true,
  get: function get() {
    return _Flickr["default"];
  }
});
Object.defineProperty(exports, "FlickrSquare", {
  enumerable: true,
  get: function get() {
    return _FlickrSquare["default"];
  }
});
Object.defineProperty(exports, "Foursquare", {
  enumerable: true,
  get: function get() {
    return _Foursquare["default"];
  }
});
Object.defineProperty(exports, "FoursquareSquare", {
  enumerable: true,
  get: function get() {
    return _FoursquareSquare["default"];
  }
});
Object.defineProperty(exports, "Google", {
  enumerable: true,
  get: function get() {
    return _Google["default"];
  }
});
Object.defineProperty(exports, "GoogleSquare", {
  enumerable: true,
  get: function get() {
    return _GoogleSquare["default"];
  }
});
Object.defineProperty(exports, "Googleplus", {
  enumerable: true,
  get: function get() {
    return _Googleplus["default"];
  }
});
Object.defineProperty(exports, "GoogleplusSquare", {
  enumerable: true,
  get: function get() {
    return _GoogleplusSquare["default"];
  }
});
Object.defineProperty(exports, "Instagram", {
  enumerable: true,
  get: function get() {
    return _Instagram["default"];
  }
});
Object.defineProperty(exports, "InstagramSquare", {
  enumerable: true,
  get: function get() {
    return _InstagramSquare["default"];
  }
});
Object.defineProperty(exports, "Linkedin", {
  enumerable: true,
  get: function get() {
    return _Linkedin["default"];
  }
});
Object.defineProperty(exports, "LinkedinSquare", {
  enumerable: true,
  get: function get() {
    return _LinkedinSquare["default"];
  }
});
Object.defineProperty(exports, "Pinterest", {
  enumerable: true,
  get: function get() {
    return _Pinterest["default"];
  }
});
Object.defineProperty(exports, "PinterestSquare", {
  enumerable: true,
  get: function get() {
    return _PinterestSquare["default"];
  }
});
Object.defineProperty(exports, "Snapchat", {
  enumerable: true,
  get: function get() {
    return _Snapchat["default"];
  }
});
Object.defineProperty(exports, "SnapchatSquare", {
  enumerable: true,
  get: function get() {
    return _SnapchatSquare["default"];
  }
});
Object.defineProperty(exports, "Tumblr", {
  enumerable: true,
  get: function get() {
    return _Tumblr["default"];
  }
});
Object.defineProperty(exports, "TumblrSquare", {
  enumerable: true,
  get: function get() {
    return _TumblrSquare["default"];
  }
});
Object.defineProperty(exports, "Twitter", {
  enumerable: true,
  get: function get() {
    return _Twitter["default"];
  }
});
Object.defineProperty(exports, "TwitterSquare", {
  enumerable: true,
  get: function get() {
    return _TwitterSquare["default"];
  }
});
Object.defineProperty(exports, "Vimeo", {
  enumerable: true,
  get: function get() {
    return _Vimeo["default"];
  }
});
Object.defineProperty(exports, "VimeoSquare", {
  enumerable: true,
  get: function get() {
    return _VimeoSquare["default"];
  }
});
Object.defineProperty(exports, "Vine", {
  enumerable: true,
  get: function get() {
    return _Vine["default"];
  }
});
Object.defineProperty(exports, "VineSquare", {
  enumerable: true,
  get: function get() {
    return _VineSquare["default"];
  }
});
Object.defineProperty(exports, "Wordpress", {
  enumerable: true,
  get: function get() {
    return _Wordpress["default"];
  }
});
Object.defineProperty(exports, "WordpressSquare", {
  enumerable: true,
  get: function get() {
    return _WordpressSquare["default"];
  }
});
Object.defineProperty(exports, "Youtube", {
  enumerable: true,
  get: function get() {
    return _Youtube["default"];
  }
});
Object.defineProperty(exports, "YoutubeSquare", {
  enumerable: true,
  get: function get() {
    return _YoutubeSquare["default"];
  }
});
Object.defineProperty(exports, "GridView", {
  enumerable: true,
  get: function get() {
    return _GridView["default"];
  }
});
Object.defineProperty(exports, "ListView", {
  enumerable: true,
  get: function get() {
    return _ListView["default"];
  }
});
Object.defineProperty(exports, "Order", {
  enumerable: true,
  get: function get() {
    return _Order["default"];
  }
});
Object.defineProperty(exports, "OrderFromBottom", {
  enumerable: true,
  get: function get() {
    return _OrderFromBottom["default"];
  }
});
Object.defineProperty(exports, "OrderFromTop", {
  enumerable: true,
  get: function get() {
    return _OrderFromTop["default"];
  }
});
Object.defineProperty(exports, "ResultsMapView", {
  enumerable: true,
  get: function get() {
    return _ResultsMapView["default"];
  }
});
Object.defineProperty(exports, "ResultsView", {
  enumerable: true,
  get: function get() {
    return _ResultsView["default"];
  }
});
Object.defineProperty(exports, "SlideshowView", {
  enumerable: true,
  get: function get() {
    return _SlideshowView["default"];
  }
});
Object.defineProperty(exports, "Angry", {
  enumerable: true,
  get: function get() {
    return _Angry["default"];
  }
});
Object.defineProperty(exports, "Happy", {
  enumerable: true,
  get: function get() {
    return _Happy["default"];
  }
});
Object.defineProperty(exports, "Sad", {
  enumerable: true,
  get: function get() {
    return _Sad["default"];
  }
});
Object.defineProperty(exports, "Wow", {
  enumerable: true,
  get: function get() {
    return _Wow["default"];
  }
});
Object.defineProperty(exports, "PlennyColor", {
  enumerable: true,
  get: function get() {
    return _PlennyColor["default"];
  }
});

var _Add = _interopRequireDefault(require("./icons/arrows/Add"));

var _AddCircle = _interopRequireDefault(require("./icons/arrows/AddCircle"));

var _ArrowDoubleDown = _interopRequireDefault(require("./icons/arrows/ArrowDoubleDown"));

var _ArrowDoubleLeft = _interopRequireDefault(require("./icons/arrows/ArrowDoubleLeft"));

var _ArrowDoubleRight = _interopRequireDefault(require("./icons/arrows/ArrowDoubleRight"));

var _ArrowDoubleUp = _interopRequireDefault(require("./icons/arrows/ArrowDoubleUp"));

var _ArrowDown = _interopRequireDefault(require("./icons/arrows/ArrowDown"));

var _ArrowLeft = _interopRequireDefault(require("./icons/arrows/ArrowLeft"));

var _ArrowRight = _interopRequireDefault(require("./icons/arrows/ArrowRight"));

var _ArrowUp = _interopRequireDefault(require("./icons/arrows/ArrowUp"));

var _ArrowLongDown = _interopRequireDefault(require("./icons/arrows/ArrowLongDown"));

var _ArrowLongLeft = _interopRequireDefault(require("./icons/arrows/ArrowLongLeft"));

var _ArrowLongRight = _interopRequireDefault(require("./icons/arrows/ArrowLongRight"));

var _ArrowLongUp = _interopRequireDefault(require("./icons/arrows/ArrowLongUp"));

var _ArrowFillDown = _interopRequireDefault(require("./icons/arrows/ArrowFillDown"));

var _ArrowFillLeft = _interopRequireDefault(require("./icons/arrows/ArrowFillLeft"));

var _ArrowFillRight = _interopRequireDefault(require("./icons/arrows/ArrowFillRight"));

var _ArrowFillUp = _interopRequireDefault(require("./icons/arrows/ArrowFillUp"));

var _Check = _interopRequireDefault(require("./icons/arrows/Check"));

var _Checked = _interopRequireDefault(require("./icons/arrows/Checked"));

var _CheckedAll = _interopRequireDefault(require("./icons/arrows/CheckedAll"));

var _Close = _interopRequireDefault(require("./icons/arrows/Close"));

var _CloseCircle = _interopRequireDefault(require("./icons/arrows/CloseCircle"));

var _Minus = _interopRequireDefault(require("./icons/arrows/Minus"));

var _Unchecked = _interopRequireDefault(require("./icons/arrows/Unchecked"));

var _UncheckedAll = _interopRequireDefault(require("./icons/arrows/UncheckedAll"));

var _Cn = _interopRequireDefault(require("./icons/brands/Cn"));

var _Dev = _interopRequireDefault(require("./icons/brands/Dev"));

var _Osn = _interopRequireDefault(require("./icons/brands/Osn"));

var _Pn = _interopRequireDefault(require("./icons/brands/Pn"));

var _Osnsocial = _interopRequireDefault(require("./icons/brands/Osnsocial"));

var _Cellphone = _interopRequireDefault(require("./icons/contact/Cellphone"));

var _Mail = _interopRequireDefault(require("./icons/contact/Mail"));

var _Phone = _interopRequireDefault(require("./icons/contact/Phone"));

var _Skype = _interopRequireDefault(require("./icons/contact/Skype"));

var _SkypeSquare = _interopRequireDefault(require("./icons/contact/SkypeSquare"));

var _Website = _interopRequireDefault(require("./icons/contact/Website"));

var _Whatsapp = _interopRequireDefault(require("./icons/contact/Whatsapp"));

var _WhatsappSquare = _interopRequireDefault(require("./icons/contact/WhatsappSquare"));

var _Ads = _interopRequireDefault(require("./icons/general/Ads"));

var _Afternoon = _interopRequireDefault(require("./icons/general/Afternoon"));

var _Analytics = _interopRequireDefault(require("./icons/general/Analytics"));

var _Archive = _interopRequireDefault(require("./icons/general/Archive"));

var _Badge = _interopRequireDefault(require("./icons/general/Badge"));

var _BellFill = _interopRequireDefault(require("./icons/general/BellFill"));

var _Belgium = _interopRequireDefault(require("./icons/general/Belgium"));

var _Bin = _interopRequireDefault(require("./icons/general/Bin"));

var _Birthday = _interopRequireDefault(require("./icons/general/Birthday"));

var _Briefcase = _interopRequireDefault(require("./icons/general/Briefcase"));

var _Calendar = _interopRequireDefault(require("./icons/general/Calendar"));

var _Chain = _interopRequireDefault(require("./icons/general/Chain"));

var _ChainBroken = _interopRequireDefault(require("./icons/general/ChainBroken"));

var _Clipboard = _interopRequireDefault(require("./icons/general/Clipboard"));

var _Coin = _interopRequireDefault(require("./icons/general/Coin"));

var _Copyright = _interopRequireDefault(require("./icons/general/Copyright"));

var _Cread = _interopRequireDefault(require("./icons/general/Cread"));

var _Crown = _interopRequireDefault(require("./icons/general/Crown"));

var _Dashboard = _interopRequireDefault(require("./icons/general/Dashboard"));

var _Discount = _interopRequireDefault(require("./icons/general/Discount"));

var _Dnd = _interopRequireDefault(require("./icons/general/Dnd"));

var _Edit = _interopRequireDefault(require("./icons/general/Edit"));

var _Entrepreneur = _interopRequireDefault(require("./icons/general/Entrepreneur"));

var _Eshop = _interopRequireDefault(require("./icons/general/Eshop"));

var _Facilities = _interopRequireDefault(require("./icons/general/Facilities"));

var _Favorite = _interopRequireDefault(require("./icons/general/Favorite"));

var _FavoriteFill = _interopRequireDefault(require("./icons/general/FavoriteFill"));

var _Fax = _interopRequireDefault(require("./icons/general/Fax"));

var _Filter = _interopRequireDefault(require("./icons/general/Filter"));

var _Groups = _interopRequireDefault(require("./icons/general/Groups"));

var _Hidden = _interopRequireDefault(require("./icons/general/Hidden"));

var _Home = _interopRequireDefault(require("./icons/general/Home"));

var _Image = _interopRequireDefault(require("./icons/general/Image"));

var _Import = _interopRequireDefault(require("./icons/general/Import"));

var _InfinitySign = _interopRequireDefault(require("./icons/general/InfinitySign"));

var _Info = _interopRequireDefault(require("./icons/general/Info"));

var _Keywords = _interopRequireDefault(require("./icons/general/Keywords"));

var _Label = _interopRequireDefault(require("./icons/general/Label"));

var _Loading = _interopRequireDefault(require("./icons/general/Loading"));

var _Locked = _interopRequireDefault(require("./icons/general/Locked"));

var _Logout = _interopRequireDefault(require("./icons/general/Logout"));

var _Magazines = _interopRequireDefault(require("./icons/general/Magazines"));

var _Mapmarker = _interopRequireDefault(require("./icons/general/Mapmarker"));

var _MapmarkerFill = _interopRequireDefault(require("./icons/general/MapmarkerFill"));

var _Menudotted = _interopRequireDefault(require("./icons/general/Menudotted"));

var _MenudottedFill = _interopRequireDefault(require("./icons/general/MenudottedFill"));

var _MenuFill = _interopRequireDefault(require("./icons/general/MenuFill"));

var _Morning = _interopRequireDefault(require("./icons/general/Morning"));

var _Nacebel = _interopRequireDefault(require("./icons/general/Nacebel"));

var _Newsletter = _interopRequireDefault(require("./icons/general/Newsletter"));

var _OpeningHours = _interopRequireDefault(require("./icons/general/OpeningHours"));

var _OpenMap = _interopRequireDefault(require("./icons/general/OpenMap"));

var _PaperPlane = _interopRequireDefault(require("./icons/general/PaperPlane"));

var _Pin = _interopRequireDefault(require("./icons/general/Pin"));

var _PinFill = _interopRequireDefault(require("./icons/general/PinFill"));

var _Post = _interopRequireDefault(require("./icons/general/Post"));

var _Protection = _interopRequireDefault(require("./icons/general/Protection"));

var _Qr = _interopRequireDefault(require("./icons/general/Qr"));

var _QuoteClosed = _interopRequireDefault(require("./icons/general/QuoteClosed"));

var _QuoteClosedFill = _interopRequireDefault(require("./icons/general/QuoteClosedFill"));

var _QuoteOpen = _interopRequireDefault(require("./icons/general/QuoteOpen"));

var _QuoteOpenFill = _interopRequireDefault(require("./icons/general/QuoteOpenFill"));

var _Ranking = _interopRequireDefault(require("./icons/general/Ranking"));

var _Repeat = _interopRequireDefault(require("./icons/general/Repeat"));

var _Save = _interopRequireDefault(require("./icons/general/Save"));

var _Search = _interopRequireDefault(require("./icons/general/Search"));

var _Settings = _interopRequireDefault(require("./icons/general/Settings"));

var _Share = _interopRequireDefault(require("./icons/general/Share"));

var _Team = _interopRequireDefault(require("./icons/general/Team"));

var _ThumbsUp = _interopRequireDefault(require("./icons/general/ThumbsUp"));

var _Unlocked = _interopRequireDefault(require("./icons/general/Unlocked"));

var _Upload = _interopRequireDefault(require("./icons/general/Upload"));

var _UserF = _interopRequireDefault(require("./icons/general/UserF"));

var _UserM = _interopRequireDefault(require("./icons/general/UserM"));

var _Video = _interopRequireDefault(require("./icons/general/Video"));

var _Visible = _interopRequireDefault(require("./icons/general/Visible"));

var _Computer = _interopRequireDefault(require("./icons/general/Computer"));

var _Bakery = _interopRequireDefault(require("./icons/general/Bakery"));

var _Verified = _interopRequireDefault(require("./icons/general/Verified"));

var _GaultMillau = _interopRequireDefault(require("./icons/services/associations/GaultMillau"));

var _Michelin = _interopRequireDefault(require("./icons/services/associations/Michelin"));

var _Michelin2star = _interopRequireDefault(require("./icons/services/associations/Michelin2star"));

var _Michelin3star = _interopRequireDefault(require("./icons/services/associations/Michelin3star"));

var _Star = _interopRequireDefault(require("./icons/services/associations/Star"));

var _StarFill = _interopRequireDefault(require("./icons/services/associations/StarFill"));

var _AC = _interopRequireDefault(require("./icons/services/facilities/AC"));

var _BpostFill = _interopRequireDefault(require("./icons/services/facilities/BpostFill"));

var _Breakfast = _interopRequireDefault(require("./icons/services/facilities/Breakfast"));

var _Gym = _interopRequireDefault(require("./icons/services/facilities/Gym"));

var _HotelBar = _interopRequireDefault(require("./icons/services/facilities/HotelBar"));

var _NoPetsAllowed = _interopRequireDefault(require("./icons/services/facilities/NoPetsAllowed"));

var _Parking = _interopRequireDefault(require("./icons/services/facilities/Parking"));

var _PetsAllowed = _interopRequireDefault(require("./icons/services/facilities/PetsAllowed"));

var _PicnicBench = _interopRequireDefault(require("./icons/services/facilities/PicnicBench"));

var _Restaurant = _interopRequireDefault(require("./icons/services/facilities/Restaurant"));

var _Spa = _interopRequireDefault(require("./icons/services/facilities/Spa"));

var _SwimmingPool = _interopRequireDefault(require("./icons/services/facilities/SwimmingPool"));

var _TwentyFourHourReception = _interopRequireDefault(require("./icons/services/facilities/TwentyFourHourReception"));

var _Ups = _interopRequireDefault(require("./icons/services/facilities/Ups"));

var _UpsFill = _interopRequireDefault(require("./icons/services/facilities/UpsFill"));

var _WeelchairFriendly = _interopRequireDefault(require("./icons/services/facilities/WeelchairFriendly"));

var _Wifi = _interopRequireDefault(require("./icons/services/facilities/Wifi"));

var _AmericanExpress = _interopRequireDefault(require("./icons/services/payment-methods/AmericanExpress"));

var _AndroidPay = _interopRequireDefault(require("./icons/services/payment-methods/AndroidPay"));

var _ApplePay = _interopRequireDefault(require("./icons/services/payment-methods/ApplePay"));

var _Bancontact = _interopRequireDefault(require("./icons/services/payment-methods/Bancontact"));

var _Bonz = _interopRequireDefault(require("./icons/services/payment-methods/Bonz"));

var _CashEuro = _interopRequireDefault(require("./icons/services/payment-methods/CashEuro"));

var _Ecopass = _interopRequireDefault(require("./icons/services/payment-methods/Ecopass"));

var _Edenred = _interopRequireDefault(require("./icons/services/payment-methods/Edenred"));

var _GiftVoucher = _interopRequireDefault(require("./icons/services/payment-methods/GiftVoucher"));

var _GooglePay = _interopRequireDefault(require("./icons/services/payment-methods/GooglePay"));

var _Maestro = _interopRequireDefault(require("./icons/services/payment-methods/Maestro"));

var _Mastercard = _interopRequireDefault(require("./icons/services/payment-methods/Mastercard"));

var _Monizze = _interopRequireDefault(require("./icons/services/payment-methods/Monizze"));

var _Payconiq = _interopRequireDefault(require("./icons/services/payment-methods/Payconiq"));

var _Sodexo = _interopRequireDefault(require("./icons/services/payment-methods/Sodexo"));

var _TicketEcocheque = _interopRequireDefault(require("./icons/services/payment-methods/TicketEcocheque"));

var _TicketRestaurant = _interopRequireDefault(require("./icons/services/payment-methods/TicketRestaurant"));

var _Visa = _interopRequireDefault(require("./icons/services/payment-methods/Visa"));

var _Vpay = _interopRequireDefault(require("./icons/services/payment-methods/Vpay"));

var _Behance = _interopRequireDefault(require("./icons/social-media/Behance"));

var _BehanceSquare = _interopRequireDefault(require("./icons/social-media/BehanceSquare"));

var _Deviantart = _interopRequireDefault(require("./icons/social-media/Deviantart"));

var _DeviantartSquare = _interopRequireDefault(require("./icons/social-media/DeviantartSquare"));

var _Dribbble = _interopRequireDefault(require("./icons/social-media/Dribbble"));

var _DribbbleSquare = _interopRequireDefault(require("./icons/social-media/DribbbleSquare"));

var _Facebook = _interopRequireDefault(require("./icons/social-media/Facebook"));

var _FacebookSquare = _interopRequireDefault(require("./icons/social-media/FacebookSquare"));

var _Flickr = _interopRequireDefault(require("./icons/social-media/Flickr"));

var _FlickrSquare = _interopRequireDefault(require("./icons/social-media/FlickrSquare"));

var _Foursquare = _interopRequireDefault(require("./icons/social-media/Foursquare"));

var _FoursquareSquare = _interopRequireDefault(require("./icons/social-media/FoursquareSquare"));

var _Google = _interopRequireDefault(require("./icons/social-media/Google"));

var _GoogleSquare = _interopRequireDefault(require("./icons/social-media/GoogleSquare"));

var _Googleplus = _interopRequireDefault(require("./icons/social-media/Googleplus"));

var _GoogleplusSquare = _interopRequireDefault(require("./icons/social-media/GoogleplusSquare"));

var _Instagram = _interopRequireDefault(require("./icons/social-media/Instagram"));

var _InstagramSquare = _interopRequireDefault(require("./icons/social-media/InstagramSquare"));

var _Linkedin = _interopRequireDefault(require("./icons/social-media/Linkedin"));

var _LinkedinSquare = _interopRequireDefault(require("./icons/social-media/LinkedinSquare"));

var _Pinterest = _interopRequireDefault(require("./icons/social-media/Pinterest"));

var _PinterestSquare = _interopRequireDefault(require("./icons/social-media/PinterestSquare"));

var _Snapchat = _interopRequireDefault(require("./icons/social-media/Snapchat"));

var _SnapchatSquare = _interopRequireDefault(require("./icons/social-media/SnapchatSquare"));

var _Tumblr = _interopRequireDefault(require("./icons/social-media/Tumblr"));

var _TumblrSquare = _interopRequireDefault(require("./icons/social-media/TumblrSquare"));

var _Twitter = _interopRequireDefault(require("./icons/social-media/Twitter"));

var _TwitterSquare = _interopRequireDefault(require("./icons/social-media/TwitterSquare"));

var _Vimeo = _interopRequireDefault(require("./icons/social-media/Vimeo"));

var _VimeoSquare = _interopRequireDefault(require("./icons/social-media/VimeoSquare"));

var _Vine = _interopRequireDefault(require("./icons/social-media/Vine"));

var _VineSquare = _interopRequireDefault(require("./icons/social-media/VineSquare"));

var _Wordpress = _interopRequireDefault(require("./icons/social-media/Wordpress"));

var _WordpressSquare = _interopRequireDefault(require("./icons/social-media/WordpressSquare"));

var _Youtube = _interopRequireDefault(require("./icons/social-media/Youtube"));

var _YoutubeSquare = _interopRequireDefault(require("./icons/social-media/YoutubeSquare"));

var _GridView = _interopRequireDefault(require("./icons/view-manipulation/GridView"));

var _ListView = _interopRequireDefault(require("./icons/view-manipulation/ListView"));

var _Order = _interopRequireDefault(require("./icons/view-manipulation/Order"));

var _OrderFromBottom = _interopRequireDefault(require("./icons/view-manipulation/OrderFromBottom"));

var _OrderFromTop = _interopRequireDefault(require("./icons/view-manipulation/OrderFromTop"));

var _ResultsMapView = _interopRequireDefault(require("./icons/view-manipulation/ResultsMapView"));

var _ResultsView = _interopRequireDefault(require("./icons/view-manipulation/ResultsView"));

var _SlideshowView = _interopRequireDefault(require("./icons/view-manipulation/SlideshowView"));

var _Angry = _interopRequireDefault(require("./icons/emojis/Angry"));

var _Happy = _interopRequireDefault(require("./icons/emojis/Happy"));

var _Sad = _interopRequireDefault(require("./icons/emojis/Sad"));

var _Wow = _interopRequireDefault(require("./icons/emojis/Wow"));

var _PlennyColor = _interopRequireDefault(require("./icons/shoppa/PlennyColor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }